"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrors = getErrors;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
function getErrors(inputsMap) {
  const errors = {};
  (0, _forEach.default)(inputsMap).call(inputsMap, (inputState, inputElement) => {
    // value, key
    if (inputState.errorStateOverride && inputState.errorStateOverride.rule) {
      errors[inputElement.name] = {
        ...inputState.errorStateOverride
      };
    } else if (inputState.errorState && inputState.errorState.rule) {
      errors[inputElement.name] = {
        ...inputState.errorState
      };
    }
  });
  return errors;
}